// @flow
import invariant from 'common/utils/invariant';
import { ClientConfig } from 'common/models/internal/ClientConfig';

class ClientConfigService {
    static _config: ?ClientConfig = null;

    static init(config: ClientConfig) {
        this._config = config;
    }

    static isRbacEnabled(): boolean {
        invariant(
            ClientConfigService._config,
            'ClientConfigService is used before initialization'
        );
        return ClientConfigService._config.isRbacEnabled;
    }

    static isAlertsEnabled(): boolean {
        invariant(
            ClientConfigService._config,
            'ClientConfigService is used before initialization'
        );
        return ClientConfigService._config.isAlertsEnabled;
    }

    static isUpsellEnabled(): boolean {
        invariant(
            ClientConfigService._config,
            'ClientConfigService is used before initialization'
        );
        return ClientConfigService._config.isUpsellEnabled;
    }
}

export default ClientConfigService;
